module.exports = __webpack_public_path__ + "img/tph-group.588bbaec.png";